import { forwardRef, HTMLProps } from 'react';
import s from './card.module.css';
import cn from 'classnames';
import { LangSelect } from '../../features/lang-select/lang-select';

interface Props extends HTMLProps<HTMLDivElement> {
  title?: string;
  withLang?: boolean;
}
export const Card = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className, title, withLang, children, ...other } = props;

  return (
    <div className={cn(s.component, className)} ref={ref} data-testid={other.id} {...other}>
      {title && (
        <h3 className={s.title}>
          {title}
          {withLang && <LangSelect />}
        </h3>
      )}
      {children}
    </div>
  );
});
